import { ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuxiliaryDataFieldSchemaInterface, AuxiliaryDataSearchStringOperation } from '@vendasta/account-group';
import { DropdownRendererComponent } from '../../renderers/dropdown';
import { AuxiliaryDataSearchInfoInterface, FilterHandler } from '../auxiliary-data-accounts-table-filters.service';

export class DropdownFilterHandler implements FilterHandler {
  formControl: FormControl;
  schema: AuxiliaryDataFieldSchemaInterface;

  constructor(public fieldSchema: AuxiliaryDataFieldSchemaInterface) {
    this.formControl = new FormControl();
    this.formControl.setValidators([]);
    this.schema = fieldSchema;
  }

  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    const component = viewContainerRef.createComponent<DropdownRendererComponent>(DropdownRendererComponent);
    component.instance.control = this.formControl;
    component.instance.label = '';
    component.instance.dropdownOptions = this.schema?.dropdownOptions.map((d) => ({ value: d.value, label: d.label }));
    component.instance.validators = [];
    component.instance.readOnly = false;
  }
  filterOperation(operation: AuxiliaryDataSearchStringOperation): AuxiliaryDataSearchInfoInterface {
    return {
      filter: {
        fieldId: this.schema?.fieldId,
        operation: {
          dropdownOperation: operation,
        },
        stringFilterValue: this.formControl?.value,
      },
      fieldName: this.schema?.fieldName,
      filterValue: this.formControl?.value,
      operationName: AuxiliaryDataSearchStringOperation.STRING_EQUALS ? 'equals' : 'does not equals',
    };
  }

  hasModification(): boolean {
    return this.formControl.dirty;
  }
}
